<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer013">
<p class="normal4"><span class="charoverride3"><br class="calibre4"/></span></p>
<p class="normal4"><span class="charoverride3">In loving memory of Baffi, my feline muse<br class="calibre7"/>for this book and all the others.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?740e2a8a